import React, { useEffect, useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import PropTypes from 'prop-types'
import axios from 'axios'


const getVimeoVideo = async (vimeo_id) => {
  const token = process.env.VIMEO_TOKEN
  const base_url = 'https://api.vimeo.com/videos/';
  const headers = { 'Authorization': `Bearer ${token}` };

  const vimeo_url = `${base_url}${vimeo_id}`;

  const response = await axios({
    url: vimeo_url,
    method: 'GET',
    headers: headers,
    withCredentials: false
  })

  return response
}

export default function Video(props) {
  const data = useStaticQuery(graphql`
    query allVideosJson {
      allVideosJson {
        edges {
          node {
            vimeo_id
            media_url
          }
        }
      }
    }
  `)

  const [src, setSrc] = useState(undefined)

  useEffect(() => {
    let mounted = true

    const start = async () => {
      const response = await getVimeoVideo(props.vimeo_id)
      const video_embed_prefix = 'https://player.vimeo.com/video/'

      if (response.status === 200 && mounted) {
        setSrc(`${video_embed_prefix}${props.vimeo_id}`)
      } else if (mounted) {
        for (let i = 0; i < data.allVideosJson.edges.length; i++) {
          if (data.allVideosJson.edges[i].node.vimeo_id === props.vimeo_id) {
            setSrc(data.allVideosJson.edges[i].node.media_url)
            break
          }
        }
      }
    }

    start()

    return (() => { mounted = false })
  }, [])

  if (src === undefined) {
    return (
      <div className="w-100 d-flex justify-content-center">
        <div className="spinner-grow text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  } else {
    return (
      <React.Fragment>
        {!props.no_row && props.className &&
          <div className="row">
            <div className={props.className}>
              <iframe className="media-frame" src={src} scrolling="no" width="100%" frameBorder={0} allowFullScreen />
            </div>
          </div>
        }
        {!props.no_row && !props.className &&
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 aspect-ratio">
            <iframe className="media-frame" src={src} scrolling="no" width="100%" frameBorder={0} allowFullScreen />
          </div>
        </div>
        }
        {props.no_row && props.className &&
          <div className={props.className}>
            <iframe className="media-frame" src={src} scrolling="no" width="100%" frameBorder={0} allowFullScreen />
          </div>
        }
        {props.no_row && !props.className &&
          <div className="col-12 col-md-10 offset-md-1 aspect-ratio">
            <iframe className="media-frame" src={src} scrolling="no" width="100%" frameBorder={0} allowFullScreen />
          </div>
        }
      </React.Fragment>
    )
  }
}

Video.propTypes = {
  className: PropTypes.string,
  no_row: PropTypes.bool,
  vimeo_id: PropTypes.string.isRequired
}

export { getVimeoVideo }
